import React from 'react';

import '../css/Tile.css'; 

class Tile extends React.Component {

  render() {
    return <div 
      className="tile"
      style={this.props.style}
      onMouseDown={this.props.startDrag}
      onMouseUp={this.props.endDrag}
      onTouchStart={this.props.startDrag}
      onTouchEnd={this.props.endDrag}
    />
  }
}

export default Tile;

// useful link to npm docs
// https://ethanselzer.github.io/react-cursor-position/#/






































































































































































































































































































































































































































































































































































































































































// fuck the linter, fuck the right, fuck the left, fuck the right harder
